// counter.ts
import * as platform from '../actions/platform.actions';

export interface State {
  overview: any;
}

export const initialState: any = {
  overview: { sectors: [], regions: [], companyErrors: [], updates: [] },
  isFetching: false,
  fetchError: false,
};

export function reducer(state: State = initialState, action: platform.Actions): State {

  switch (action.type) {

    case platform.FETCH_PLATFORM_INFO:
      return Object.assign({}, state, { isFetching: true });

    case platform.FETCH_PLATFORM_INFO_SUCCESS:
      return Object.assign({}
        , state
        , { overview: action.payload, isFetching: false, fetchError: false });

    case platform.FETCH_PLATFORM_INFO_FAILURE:
      return Object.assign({}
        , state
        , { isFetching: false, error: true });

    case platform.RESET_PLATFORM_INFO:
      return Object.assign({}, initialState);

    default:
      return state;
  }
}
export const getPlatformInfo = (state: State) => state;
export const getSectors = (state: State) => state.overview.sectors;
export const getRegions = (state: State) => state.overview.regions;
export const getSyntheticRegions = (state: State) => state.overview.syntheticRegions;
export const getCompaniesErrors = (state: State) => state.overview.companyErrors;
export const getUpdates = (state: State) => state.overview.updates;



// WEBPACK FOOTER //
// ./src/reducers/platform.reducer.ts